import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Redux imports 👇
import { Provider } from 'react-redux';
import store from './services/Store'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>   {/* 👈 sabse upar wrap */}
      <App />
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
